import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { ClaimsPage } from "Order/Modules/Claim/Pages";
import { ClaimsPaths } from "Order/Modules/Claim/Routes/Routing";

export const ClaimRoutes = [
	{
		path: ClaimsPaths.Index.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderClaimModule.read}>
				<ClaimsPage />
			</PermissionGuard>
		),
	},
];
